import { Loader } from '@googlemaps/js-api-loader';
const loader = new Loader({
  apiKey: 'AIzaSyCGeik6a786d8Dt2pSTmW0TQRlTRTM8hog',
  version: 'weekly'
});

export default loader;
